import * as React from 'react';
import { Box, Divider, Stack, SxProps, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// ─── Component ────────────────────────────────────────────────────────────────

export const TrustSection = ({ sx }: { sx?: SxProps }) => (
  <Box sx={{ mt: 'auto', pt: 3, flexDirection: 'column', width: '100%', ...sx }}>
    <Divider sx={{ mb: 2 }} />
    <Typography sx={{
      fontSize: 11, fontWeight: 700, color: '#9ca3af',
      textTransform: 'uppercase', letterSpacing: '0.05em',
      textAlign: 'center', mb: 1.5,
    }}>
      Trusted By Thousands
    </Typography>
    <Stack direction="row" alignItems="center" justifyContent="center" gap={3} flexWrap="wrap">
      <LogoImg src="/assets/img/TrustPilot_4.9.png"            alt="TrustPilot" />
      <LogoImg src="/assets/img/Google-Review-Logo-png.png"    alt="Google Review" />
      <LogoImg src="/assets/img/BBB.png"                       alt="BBB" />
      <LogoImg src="/assets/img/Chamber of Commerce.png"       alt="Chamber of Commerce" sx={{height: 48}} />
    </Stack>
  </Box>
);

// ─── Styled ───────────────────────────────────────────────────────────────────

const LogoImg = styled('img')({
  width: 'auto',
  height: 40,
  objectFit: 'contain',
});
